export default __webpack_public_path__ + "static/media/Group 27228.91e71e7c.svg";